<template>
  <BaseModal 
    :show
    :title="t('app.sysadmin.modal.create_restaurant_title')"
    :show-actions="!createdRestaurant || !restaurantCreationData"
    :save-text="t('app.sysadmin.create_restaurant.create_button')"
    :loading="submitting"
    :loading-text="submitting ? 'Creando...' : ''"
    @close="handleClose"
    @save="createdRestaurant && restaurantCreationData ? handleClose() : handleSubmit()"
  >
    <div>
      <!-- Success Message with Credentials -->
      <CreateRestaurantCredentials
        v-if="createdRestaurant && restaurantCreationData"
        :created-restaurant="createdRestaurant"
        :restaurant-creation-data="restaurantCreationData"
        @copy-to-clipboard="copyToClipboard"
        @copy-welcome-message="copyWelcomeMessage"
        @copy-shareable-message="copyToClipboard(restaurantCreationData.shareable_message, 'Mensaje para Admin')"
      />

      <!-- Creation Form -->
      <CreateRestaurantForm
        v-else
        :form="form"
        :selected-plan-type="selectedPlanType"
        :selected-trial-option="selectedTrialOption"
        :custom-trial-date="customTrialDate"
        :available-plans="availablePlans"
        :min-date="minDate"
        @submit="handleSubmit"
        @update:form="form = $event"
        @update:selected-plan-type="selectedPlanType = $event"
        @update:selected-trial-option="selectedTrialOption = $event"
        @update:custom-trial-date="customTrialDate = $event"
      />
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { watch, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseModal from '@/components/common/BaseModal.vue';
import CreateRestaurantForm from './CreateRestaurantForm.vue';
import CreateRestaurantCredentials from './CreateRestaurantCredentials.vue';
import { useCreateRestaurant } from '@/composables/useCreateRestaurant';
import type { CreateRestaurantModalProps, CreateRestaurantModalEmits } from './createRestaurantTypes';

const props = defineProps<CreateRestaurantModalProps>();
const emit = defineEmits<CreateRestaurantModalEmits>();

const { t } = useI18n();

const {
  submitting,
  createdRestaurant,
  restaurantCreationData,
  selectedTrialOption,
  customTrialDate,
  availablePlans,
  selectedPlanType,
  form,
  minDate,
  resetForm,
  loadPlans,
  handleSubmit,
  copyToClipboard,
  copyWelcomeMessage
} = useCreateRestaurant();

const handleClose = () => {
  if (createdRestaurant.value) {
    emit('created');
  }
  resetForm();
  emit('close');
};

watch(() => props.show, (newValue) => {
  if (newValue) {
    resetForm();
    loadPlans();
  }
});

onMounted(() => {
  loadPlans();
});
</script>
